import { Component, Inject, Optional } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';

@Component({
  selector: 'qa-web-client-health-check',
  standalone: true,
  imports: [
    MatDialogTitle,
    TranslateModule,
    ButtonComponent,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './web-client-health-check.component.html',
  styleUrl: './web-client-health-check.component.scss',
})
export class WebClientHealthCheckComponent {
  constructor(
    @Optional()
    public dialogRef: MatDialogRef<WebClientHealthCheckComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
